import {jsonObject} from 'typedjson';
import {LoraPacketType} from '@/model/lora/LoraPacket/LoraPacketType';
import {LoraPacket} from '@/model/lora/LoraPacket/LoraPacket';


@jsonObject
export class LoraPacketDownlink extends LoraPacket {

  public get Type(): LoraPacketType {
    return LoraPacketType.Downlink;
  }
}

